import { GroupsOfGroup } from '@era/security-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const GroupsOfGroupResolverActions = createActionGroup({
  source: 'Groups Of Group Resolver',
  events: {
    'User groups requested': props<{ groupId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const GroupApiActions = createActionGroup({
  source: 'Group API',
  events: {
    'User groups loaded': props<{ groups: GroupsOfGroup[] }>(),
    'User groups loaded error': props<{ error: ErrorModel }>(),
  },
});
